/* "A new version is ready".

   A bar, not a modal. An update is available, not urgent — the running app
   still works — so it asks from the edge of the screen and is dismissible.
   Blocking the user to tell them about a deploy is the kind of thing that
   makes people avoid installing web apps.

   It sits above the tab bar and slides in from below, the same direction and
   with the same spring as every other transient surface in the app. */

import { useEffect, useState } from 'react'
import { AnimatePresence, motion, useReducedMotion } from 'motion/react'
import { RefreshCw, X } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { applyPendingUpdate, onUpdateAvailable } from './register'
import { springSheet } from '../design/motion'

export function UpdatePrompt() {
  const { t } = useTranslation()
  const reduce = useReducedMotion()
  const [available, setAvailable] = useState(false)
  const [dismissed, setDismissed] = useState(false)
  const [busy, setBusy] = useState(false)

  useEffect(() => onUpdateAvailable(setAvailable), [])

  const show = available && !dismissed

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="update-bar"
          role="status"
          initial={reduce ? { opacity: 0 } : { y: '150%', opacity: 0 }}
          animate={reduce ? { opacity: 1 } : { y: 0, opacity: 1 }}
          exit={reduce ? { opacity: 0 } : { y: '150%', opacity: 0 }}
          transition={reduce ? { duration: 0.12 } : springSheet}
        >
          <span className="update-text">
            <b>{t('pwa.updateTitle')}</b>
            <span>{t('pwa.updateBody')}</span>
          </span>

          <button
            type="button"
            className="btn sm pri"
            disabled={busy}
            onClick={() => {
              setBusy(true)
              void applyPendingUpdate()
            }}
          >
            <RefreshCw size={14} className={busy ? 'spin' : undefined} />
            {t('pwa.updateAction')}
          </button>

          <button
            type="button"
            className="icon-btn sm"
            onClick={() => setDismissed(true)}
            aria-label={t('common.close')}
          >
            <X size={16} />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
